var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThirdStepJourneyArabic = function SvgThirdStepJourneyArabic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.811 8.802a.805.805 0 0 1-.032 1.145.81.81 0 1 1 0-1.145zm.094-.337a1.147 1.147 0 1 0 .108 1.725 1.14 1.14 0 0 0 .042-1.621l-.1-.104zm.623-.38L5.222 2.79a.813.813 0 0 0-1.145 0L2.654 4.213a.813.813 0 0 0 0 1.144l5.296 5.307a1.824 1.824 0 0 0 2.578-2.579m-2.817 2.818a2.161 2.161 0 0 0 3.056-3.056L5.459 2.55a1.15 1.15 0 0 0-1.62 0L2.414 3.975a1.15 1.15 0 0 0 0 1.62z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.75 11.534a1.15 1.15 0 0 1-1.15-1.15v-2.02a1.15 1.15 0 0 1 1.15-1.15h2.273l3.688 3.689a2.15 2.15 0 0 0 1.525.631zm5.78-.337H1.75a.813.813 0 0 1-.813-.813v-2.02a.813.813 0 0 1 .813-.812h2.133l3.59 3.59z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.061 1.886v7.489a1.822 1.822 0 1 1-3.644 0v-7.49a.813.813 0 0 1 .812-.812h2.02a.813.813 0 0 1 .812.813m-.675 7.49a1.153 1.153 0 1 0-1.146 1.146h.001l-.002-.337v.337h.001a1.147 1.147 0 0 0 1.146-1.146m-.337-.001h.337v.002zm1.35 0v-7.49a1.15 1.15 0 0 0-1.15-1.15h-2.02a1.15 1.15 0 0 0-1.15 1.15v7.49a2.16 2.16 0 0 0 4.32 0",
    clipRule: "evenodd"
  })));
};
export default SvgThirdStepJourneyArabic;